import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://35cb21f19142972332bf65e179908c19@o4507004015607808.ingest.us.sentry.io/4507004017115136",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});